// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VGt0g","actions":"styles_actions__1m3E_","error":"styles_error__1GfIs","message":"styles_message__3AlyZ"};